import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-educational-resource-list',
    templateUrl: './educational-resource.component.html',
    imports: [CommonModule,],
    styleUrls: ['./educational-resource.component.css']
})
export class EducationalResourceComponent {
  @Input('data')data:any[]=[]
  @Output('fileData') fileData = new EventEmitter<any>();
  
  getFile(el:any){
    this.fileData.emit(el)
  }
}

